import { Badge } from "@/components/ui/badge";
import { Zap, Cloud, Code, Users, Lock, BarChart, Cpu } from "lucide-react";

const PositioningStatement = () => {
  const coreStrengths = [
    { icon: Cpu, label: "AI + Cloud", color: "from-blue-500 to-cyan-500" },
    {
      icon: Code,
      label: "Custom Software",
      color: "from-purple-500 to-pink-500",
    },
    {
      icon: Users,
      label: "Mobile & Web Apps",
      color: "from-primary to-secondary",
    },
    {
      icon: Zap,
      label: "DevOps & Automation",
      color: "from-secondary to-primary",
    },
    {
      icon: BarChart,
      label: "Data Engineering",
      color: "from-green-500 to-emerald-500",
    },
    { icon: Lock, label: "Cybersecurity", color: "from-red-500 to-pink-500" },
    {
      icon: Cloud,
      label: "Offshore Development Centers",
      color: "from-indigo-500 to-purple-500",
    },
  ];

  return (
    <section className="py-8 bg-gradient-to-b from-background via-secondary/5 to-muted/30 border-y border-secondary/20">
      <div className="container mx-auto px-4">
        <div className="text-center mb-6">
          <Badge className="mb-3 bg-secondary/10 text-secondary border-secondary/30">
            Enterprise-Grade IT Services
          </Badge>
          <h2 className="text-3xl md:text-4xl font-bold mb-3 text-foreground">
            <span className="bg-duo-gradient bg-clip-text text-transparent">Smartborn delivers enterprise software, cloud infrastructure, and dedicated engineering teams</span>
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            Serving enterprise clients across manufacturing, healthcare, retail,
            and technology sectors
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4 max-w-5xl mx-auto">
          {coreStrengths.map((strength, index) => (
            <div
              key={index}
              className="group flex items-center gap-3 px-5 py-3 bg-white/90 backdrop-blur-sm border border-border rounded-full hover:shadow-lg hover:scale-105 transition-all duration-300"
            >
              <div
                className={`bg-gradient-to-r ${strength.color} p-2 rounded-full`}
              >
                <strength.icon className="h-4 w-4 text-white" />
              </div>
              <span className="font-medium text-foreground text-sm md:text-base">
                {strength.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PositioningStatement;
